import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Actions\Admin\GetAdminCase::__invoke
* @see app/Actions/Admin/GetAdminCase.php:17
* @route '/admin/cases/{case}'
*/
export const show = (args: { case: number | { id: number } } | [caseParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/admin/cases/{case}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Actions\Admin\GetAdminCase::__invoke
* @see app/Actions/Admin/GetAdminCase.php:17
* @route '/admin/cases/{case}'
*/
show.url = (args: { case: number | { id: number } } | [caseParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { case: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { case: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            case: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        case: typeof args.case === 'object'
        ? args.case.id
        : args.case,
    }

    return show.definition.url
            .replace('{case}', parsedArgs.case.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Actions\Admin\GetAdminCase::__invoke
* @see app/Actions/Admin/GetAdminCase.php:17
* @route '/admin/cases/{case}'
*/
show.get = (args: { case: number | { id: number } } | [caseParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Actions\Admin\GetAdminCase::__invoke
* @see app/Actions/Admin/GetAdminCase.php:17
* @route '/admin/cases/{case}'
*/
show.head = (args: { case: number | { id: number } } | [caseParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Actions\Cases\ApproveCase::__invoke
* @see app/Actions/Cases/ApproveCase.php:17
* @route '/admin/cases/{case}/approve'
*/
export const approve = (args: { case: number | { id: number } } | [caseParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: approve.url(args, options),
    method: 'post',
})

approve.definition = {
    methods: ["post"],
    url: '/admin/cases/{case}/approve',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Actions\Cases\ApproveCase::__invoke
* @see app/Actions/Cases/ApproveCase.php:17
* @route '/admin/cases/{case}/approve'
*/
approve.url = (args: { case: number | { id: number } } | [caseParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { case: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { case: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            case: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        case: typeof args.case === 'object'
        ? args.case.id
        : args.case,
    }

    return approve.definition.url
            .replace('{case}', parsedArgs.case.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Actions\Cases\ApproveCase::__invoke
* @see app/Actions/Cases/ApproveCase.php:17
* @route '/admin/cases/{case}/approve'
*/
approve.post = (args: { case: number | { id: number } } | [caseParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: approve.url(args, options),
    method: 'post',
})

/**
* @see \App\Actions\Cases\ScheduleCase::__invoke
* @see app/Actions/Cases/ScheduleCase.php:17
* @route '/admin/cases/{case}/schedule'
*/
export const schedule = (args: { case: number | { id: number } } | [caseParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: schedule.url(args, options),
    method: 'post',
})

schedule.definition = {
    methods: ["post"],
    url: '/admin/cases/{case}/schedule',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Actions\Cases\ScheduleCase::__invoke
* @see app/Actions/Cases/ScheduleCase.php:17
* @route '/admin/cases/{case}/schedule'
*/
schedule.url = (args: { case: number | { id: number } } | [caseParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { case: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { case: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            case: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        case: typeof args.case === 'object'
        ? args.case.id
        : args.case,
    }

    return schedule.definition.url
            .replace('{case}', parsedArgs.case.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Actions\Cases\ScheduleCase::__invoke
* @see app/Actions/Cases/ScheduleCase.php:17
* @route '/admin/cases/{case}/schedule'
*/
schedule.post = (args: { case: number | { id: number } } | [caseParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: schedule.url(args, options),
    method: 'post',
})

const cases = {
    show: Object.assign(show, show),
    approve: Object.assign(approve, approve),
    schedule: Object.assign(schedule, schedule),
}

export default cases